module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7_1.e5c5fd76.png";